<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/Enterprisedynamics.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ AsideName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="parkOverview index_center">
      <div class="parkOverview_right">
        <div class="parkOverview_left">
          <div class="TechnicalBar">
            <el-menu
              class="el-menu-vertical-demo"
              mode="horizontal"
              active-text-color="#2968BD"
              :default-active="tabIndex.toString()"
              @select="tabClick"
            >
              <el-menu-item
                v-for="(item, index) in newsTypeList"
                :key="index"
                :index="item.id.toString()"
                @click="OpenDetail(item.id)"
              >
                <span slot="title">{{ item.newType }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>

        <div class="Dynamic flex_col">
          <div class="Dynamic_title">
            <!-- <el-divider>
              <div class="Dynamic_title_name">企业动态</div>
              <div class="Dynamic_title_text">Enterprise dynamics</div>
            </el-divider> -->
            <div class="Dynamic_title_header">
              <div class="Dynamic_title_name">
                {{ currentNewsType }}
              </div>
              <button v-if="tabIndex !== 1 && tabIndex !== 2 && tabIndex !== 6 && !loading" type="button" class="btn Dynamic_title_btn" @click="handleClick">
                {{ currentBtnText }}
              </button>
            </div>
            <el-divider></el-divider>
            <div class="Dynamic_left_last">
              <template v-if="tabIndex === 1">
                <div
                  class="Dynamic_left_content"
                  v-for="(item, index) in newsList"
                  :key="index"
                  @click="handleClick2(item.id)"
                >
                  <img
                    :src="item.imageUrl"
                    alt=""
                    mode="aspectFit"
                  />
                  <div class="Dynamic_right_content">
                    <div class="Dynamic_right_content_title">
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="Dynamic_right_content_text">
                      <p>{{ item.summary }}</p>
                    </div>
                    <div class="Dynamic_right_content_bottom">
                      <div>{{ item.createTime }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabIndex === 2">
                <!-- 登录提示 -->
                <div v-if="!isLogged" class="contribution_alert">
                  <span class="contribution_alert_text">
                    <i class="el-icon-info"></i>
                    登录后可查看征稿详情、参与投稿讨论
                  </span>
                  <button type="button" class="btn contribution_alert_btn" @click="handleClick">立即登录</button>
                </div>
                <!-- 征稿主题 -->
                <div class="contribution_section_title">征稿主题</div>
                <div
                  class="contribution_item" @click="openContributionDetail(item.id)"
                  v-for="(item, index) in newsList"
                  :key="index"
                >
                  <div class="contribution_item_header">
                    <span
                      class="contribution_tag"
                      :style="{ background: levelMap[item.level].color }"
                    >{{ levelMap[item.level].text }}</span>
                    <span class="contribution_item_title">{{ item.title }}</span>
                  </div>
                  <p class="contribution_item_desc" v-html="item.desc"></p>
                  <div class="contribution_item_footer">
                    <div class="contribution_item_meta">
                      <span>投稿截止: {{ item.deadline }}</span>
                      <span>已投稿: {{ item.submittedCount }}篇</span>
                      <span>状态: {{ contributionStatusMap[item.status] }}</span>
                    </div>
                    <button
                      v-if="item.status === 'open'"
                      type="button"
                      class="btn contribution_item_btn"
                      @click.stop="handleContribute(item)"
                    >我要投稿</button>
                    <button
                      v-else
                      type="button"
                      class="btn contribution_item_btn is_closed"
                      disabled
                    >已截止</button>
                  </div>
                </div>
              </template>
              <template v-else-if="tabIndex === 3">
                <!-- AI新闻分类筛选 -->
                <div class="ai_news_tabs">
                  <button
                    v-for="tab in aiNewsCategoryTabs"
                    :key="tab.key"
                    type="button"
                    class="btn ai_news_tab"
                    :class="{ active: activeCategory === tab.key }"
                    @click="handleCategoryChange(tab.key)"
                  >{{ tab.label }}</button>
                </div>
                <!-- AI新闻列表 -->
                <div
                  class="ai_news_item"
                  v-for="(item, index) in newsList"
                  :key="index"
                  @click="openAiNewsDetail(item.id)"
                >
                  <div class="ai_news_cover">
                    <img v-if="item.imageUrl" :src="item.imageUrl" alt="" />
                    <div v-else class="ai_news_cover_placeholder">{{ item.title }}</div>
                  </div>
                  <div class="ai_news_content">
                    <div class="ai_news_title">{{ item.title }}</div>
                    <p class="ai_news_summary">{{ item.summary }}</p>
                    <div class="ai_news_footer">
                      <span class="ai_news_tag">AI</span>
                      <span
                        v-for="badge in item.badges"
                        :key="badge"
                        class="ai_news_badge"
                        :style="{ background: badgeMap[badge].color }"
                      >{{ badgeMap[badge].text }}</span>
                      <span class="ai_news_date">{{ item.createTime }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabIndex === 4">
                <!-- 登录提示 -->
                <div v-if="!isLogged" class="contribution_alert">
                  <span class="contribution_alert_text">
                    <i class="el-icon-info"></i>
                    登录后可发布分享内容、参与评论互动
                  </span>
                  <button type="button" class="btn contribution_alert_btn" @click="handleClick">立即登录</button>
                </div>
                <!-- 帖子分类筛选 -->
                <div class="ai_news_tabs">
                  <button
                    v-for="tab in forumCategoryTabs"
                    :key="tab.key"
                    type="button"
                    class="btn ai_news_tab"
                    :class="{ active: activeForumCategory === tab.key }"
                    @click="handleForumCategoryChange(tab.key)"
                  >{{ tab.label }}</button>
                </div>
                <!-- 帖子列表 -->
                <div
                  class="forum_post_item"
                  v-for="(item, index) in newsList"
                  :key="item.id || index"
                >
                  <div
                    class="forum_post_avatar"
                    :style="{ background: avatarColors[index % avatarColors.length] }"
                  >{{ item.username.charAt(0) }}</div>
                  <div class="forum_post_body">
                    <div class="forum_post_header">
                      <span class="forum_post_username">{{ item.username }}</span>
                      <span class="forum_post_time">{{ item.createTime }}</span>
                      <button
                        v-if="isMinePost(item)"
                        type="button"
                        class="forum_post_delete"
                        @click.stop="handleDeleteForumPost(item)"
                      >删除</button>
                    </div>
                    <p class="forum_post_content">{{ item.content }}</p>
                    <div class="forum_post_tags">
                      <span
                        v-for="tag in item.tags"
                        :key="tag"
                        class="forum_post_tag"
                      >{{ tag }}</span>
                    </div>
                    <div class="forum_post_stats">
                      <button
                        type="button"
                        class="forum_stat_btn"
                        :class="{ active: item.liked }"
                        :disabled="item._likeLoading"
                        @click.stop="handleToggleLike(item)"
                      >
                        <i class="el-icon-thumb"></i> {{ item.likes || 0 }}
                      </button>
                      <button
                        type="button"
                        class="forum_stat_btn"
                        :class="{ active: item._commentOpen }"
                        @click.stop="handleToggleCommentPanel(item)"
                      >
                        <i class="el-icon-chat-dot-square"></i> {{ item.comments || 0 }}
                      </button>
                      <span><i class="el-icon-view"></i> {{ formatCount(item.views) }}</span>
                    </div>
                    <div v-if="item._commentOpen" class="forum_comment_panel" @click.stop>
                      <div v-if="isLogged" class="forum_comment_editor">
                        <el-input
                          v-model="item._commentDraft"
                          type="textarea"
                          :rows="2"
                          maxlength="500"
                          show-word-limit
                          placeholder="写下你的看法..."
                        ></el-input>
                        <el-button
                          type="primary"
                          size="mini"
                          class="forum_comment_submit"
                          :loading="item._commentSubmitting"
                          @click="handleSubmitComment(item)"
                        >发表评论</el-button>
                      </div>
                      <div v-else class="forum_comment_login_tip">
                        <span>登录后可发表评论</span>
                        <button type="button" class="btn contribution_alert_btn" @click="loginVisible = true">立即登录</button>
                      </div>
                      <div v-if="item._commentLoading" class="forum_comment_empty">评论加载中...</div>
                      <template v-else>
                        <div v-if="!(item._commentList && item._commentList.length)" class="forum_comment_empty">暂无评论，来抢沙发吧</div>
                        <div
                          v-for="comment in (item._commentList || [])"
                          :key="comment.id"
                          class="forum_comment_item"
                        >
                          <div class="forum_comment_meta">
                            <span class="forum_comment_user">{{ comment.username }}</span>
                            <span class="forum_comment_time">{{ comment.createTime }}</span>
                            <button
                              v-if="comment.mine || isMineComment(comment)"
                              type="button"
                              class="forum_comment_delete"
                              @click="handleDeleteComment(item, comment)"
                            >删除</button>
                          </div>
                          <p class="forum_comment_content">{{ comment.content }}</p>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabIndex === 5">
                <!-- 登录提示 -->
                <div v-if="!isLogged" class="contribution_alert">
                  <span class="contribution_alert_text">
                    <i class="el-icon-info"></i>
                    登录后可提交活动策划方案，查看审核进度
                  </span>
                  <button type="button" class="btn contribution_alert_btn" @click="handleClick">立即登录</button>
                </div>
                <!-- 已提交方案 -->
                <div class="contribution_section_title">已提交方案</div>
                <div class="campus_card_grid">
                  <div
                    class="campus_card"
                    v-for="(item, index) in newsList"
                    :key="index"
                    @click="openCampusProposalDetail(item.id)"
                  >
                    <div class="campus_card_stripe" :style="{ background: statusMap[item.status].color }"></div>
                    <div class="campus_card_body">
                      <div class="campus_card_school">{{ item.school }}</div>
                      <div class="campus_card_title">{{ item.title }}</div>
                      <p class="campus_card_desc" v-html="item.desc"></p>
                      <div class="campus_card_footer">
                        <span
                          class="campus_card_status"
                          :style="{ color: statusMap[item.status].color, background: statusMap[item.status].color + '1a' }"
                        >{{ statusMap[item.status].text }}</span>
                        <span class="campus_card_date">{{ item.createTime }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabIndex === 6">
                <!-- 登录提示 -->
                <div v-if="!isLogged" class="contribution_alert">
                  <span class="contribution_alert_text">
                    <i class="el-icon-info"></i>
                    登录后可在线投递简历，查看投递进度
                  </span>
                  <button type="button" class="btn contribution_alert_btn" @click="handleClick">立即登录</button>
                </div>
                <!-- 在招岗位 -->
                <div class="contribution_section_title">在招岗位</div>
                <div
                  class="job_item"
                  v-for="(item, index) in newsList"
                  :key="index"
                >
                  <div class="job_item_content">
                    <div class="job_item_header">
                      <span class="job_item_title">{{ item.title }}</span>
                      <span class="job_item_salary">{{ item.salary }}</span>
                    </div>
                    <div class="forum_post_tags">
                      <span
                        v-for="tag in item.tags"
                        :key="tag"
                        class="forum_post_tag"
                      >{{ tag }}</span>
                    </div>
                    <div class="job_item_info">
                      <span>{{ item.city }}</span>
                      <span>{{ item.jobType }}</span>
                      <span>发布于 {{ item.createTime }}</span>
                    </div>
                  </div>
                  <button type="button" class="btn job_item_btn" @click="handleDeliverResume(item)">投递简历</button>
                </div>
              </template>
            </div>
          </div>
          <div class="paging">
            <Paging
              :total="total"
              @onPageChange="onPageChange"
              :page-size="pageSize"
              :current-page="pageNumber"
            ></Paging>
          </div>
        </div>
      </div>
    </div>
    <LoginDialog :visible.sync="loginVisible" @register="handleOpenRegister"></LoginDialog>
    <RegisterDialog :visible.sync="registerVisible" @login="handleToLogin" @success="handleRegisterSuccess"></RegisterDialog>
    <ContributionDialog :visible.sync="contributionVisible" :theme="currentTheme"></ContributionDialog>
    <ShareDialog :visible.sync="shareVisible" @success="handleShareSuccess"></ShareDialog>
    <ProposalDialog :visible.sync="proposalVisible" @success="handleProposalSuccess"></ProposalDialog>
    <ResumeDialog :visible.sync="resumeVisible" :job="currentJob" @success="handleResumeSuccess"></ResumeDialog>
    <SubmitFrom></SubmitFrom>
    <Foot style="margin-top: 60px"></Foot>
  </div>
</template>
<script>
import Paging from "./components/Paging";
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";
import LoginDialog from "./components/LoginDialog";
import RegisterDialog from "./components/RegisterDialog";
import ContributionDialog from "./components/ContributionDialog";
import ShareDialog from "./components/ShareDialog";
import ProposalDialog from "./components/ProposalDialog";
import ResumeDialog from "./components/ResumeDialog";
import { getNewsListApi, getNewsTypeApi, getContributionListApi, getAiNewsListApi, getForumPostListApi, deleteForumPostApi, toggleForumLikeApi, getForumCommentListApi, saveForumCommentApi, deleteForumCommentApi, getCampusProposalListApi, getJobPositionListApi } from "@/api/index";
import { newsTypeListData, aiNewsCategoryTabs, forumCategoryTabs } from "@/data/newsData";

export default {
  name: "ParkOverview",
  components: {
    Nav,
    Foot,
    SubmitFrom,
    LoginDialog,
    RegisterDialog,
    ContributionDialog,
    ShareDialog,
    ProposalDialog,
    ResumeDialog,
    Paging,
  },
  data() {
    return {
      tabIndex: 0,
      AsideName: "企业动态",
      newsList: [],
      contributionStatusMap: {
        open: "征稿中",
        closed: "已截止",
      },
      levelMap: {
        urgent: { text: "急", color: "#f56c6c" },
        normal: { text: "征", color: "#409eff" },
        medium: { text: "中", color: "#67c23a" },
      },
      activeCategory: "all",
      aiNewsCategoryTabs,
      badgeMap: {
        hot: { text: "热门", color: "#f56c6c" },
        new: { text: "最新", color: "#67c23a" },
      },
      activeForumCategory: "all",
      forumCategoryTabs,
      avatarColors: ["#2968bd", "#e6a23c", "#f56c6c", "#67c23a", "#8e6bd0"],
      statusMap: {
        adopted: { text: "已采纳", color: "#67c23a" },
        reviewing: { text: "审核中", color: "#e6a23c" },
        pending: { text: "未采纳", color: "#c0c4cc" },
      },
      newsTypeList: [],
      pageSize: 6,
      pageNumber: 1,
      total: 0,
      currentIndex: 0,
      loginVisible: false,
      registerVisible: false,
      contributionVisible: false,
      currentTheme: null,
      shareVisible: false,
      proposalVisible: false,
      resumeVisible: false,
      currentJob: null,
      loading: false,
    };
  },
  computed: {
    //登录态：来自 auth store 模块
    isLogged() {
      return this.$store.getters["auth/isLogged"];
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
    currentUserId() {
      const info = this.$store.getters["auth/userInfo"];
      return info && info.id != null ? info.id : null;
    },
    currentNewsType() {
      const item = this.newsTypeList.find(item => item.id === this.tabIndex);
      return item ? item.newType : "";
    },
    currentBtnText() {
      if(this.tabIndex === 4) {
        return "发布分享";
      } else if(this.tabIndex === 5) {
        return "提交方案";
      } else {
        return "我要投稿";
      }
    }
  },
  created() {
    this.getNewsType();
  },
  watch: {
    loginPromptSeq(val) {
      if (!val) return;
      this.contributionVisible = false;
      this.shareVisible = false;
      this.proposalVisible = false;
      this.resumeVisible = false;
      this.registerVisible = false;
      this.loginVisible = false;
    },
  },
  mounted() {
    this.$cookies.set("tabbar", 4);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  methods: {
    //跳转详情
    handleClick2(id) {
      console.log(id);
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 4,
        },
      });
    },
    //需要登录的操作：打开登录弹窗
    //需要登录的操作：AI新闻的投稿直接开编辑器，其余打开登录弹窗
    //需要登录的操作：AI新闻投稿/发布分享直接开对应弹窗，其余打开登录弹窗
    //需要登录的操作：按 tab 分发到对应弹窗，未登录统一先弹登录
    handleClick() {
      if (!this.isLogged) {
        this.loginVisible = true;
        return;
      }
      if (this.tabIndex === 3) {
        this.handleContribute({ id: null, title: this.currentNewsType });
      } else if (this.tabIndex === 4) {
        this.shareVisible = true;
      } else if (this.tabIndex === 5) {
        this.proposalVisible = true;
      } else {
        this.loginVisible = true;
      }
    },
    //我要投稿：未登录先弹登录，已登录打开投稿编辑器
    handleContribute(item) {
      if (!this.isLogged) {
        this.loginVisible = true;
        return;
      }
      this.currentTheme = item;
      this.contributionVisible = true;
    },
    //发布分享成功：新帖子插到列表顶部
    handleShareSuccess(payload) {
      this.newsList.unshift({
        id: payload.id || Date.now(),
        userId: payload.userId || this.currentUserId,
        category: payload.category,
        avatar: payload.avatar || "",
        username: payload.username || this.$store.getters["auth/username"] || "青叶用户",
        createTime: payload.createTime || "刚刚",
        content: payload.content,
        tags: payload.tags || [],
        likes: payload.likes || 0,
        comments: payload.comments || 0,
        views: payload.views || 1,
        liked: false,
        _commentOpen: false,
        _commentList: [],
        _commentDraft: "",
        _commentLoaded: false,
      });
      this.total += 1;
    },
    isMinePost(item) {
      return this.isLogged && this.currentUserId != null && item && item.userId != null
        && String(item.userId) === String(this.currentUserId);
    },
    isMineComment(comment) {
      return this.isLogged && this.currentUserId != null && comment && comment.userId != null
        && String(comment.userId) === String(this.currentUserId);
    },
    handleToggleLike(item) {
      if (!item || !item.id) return;
      if (!this.isLogged) {
        this.loginVisible = true;
        return;
      }
      if (item._likeLoading) return;
      this.$set(item, "_likeLoading", true);
      toggleForumLikeApi({ postId: item.id }).then((res) => {
        this.$set(item, "_likeLoading", false);
        if (res.code !== 0) {
          this.$message.error(res.msg || "操作失败");
          return;
        }
        const data = res.data || {};
        this.$set(item, "liked", !!data.liked);
        this.$set(item, "likes", data.likes != null ? data.likes : item.likes);
      }).catch((err) => {
        this.$set(item, "_likeLoading", false);
        this.$message.error((err && err.msg) || "操作失败");
      });
    },
    handleToggleCommentPanel(item) {
      if (!item) return;
      const open = !item._commentOpen;
      this.$set(item, "_commentOpen", open);
      if (open && !item._commentLoaded) {
        this.loadForumComments(item);
      }
    },
    loadForumComments(item) {
      if (!item || !item.id) return;
      this.$set(item, "_commentLoading", true);
      getForumCommentListApi({
        postId: item.id,
        pageNumber: 1,
        pageSize: 50,
      }).then((res) => {
        this.$set(item, "_commentLoading", false);
        if (res.code !== 0) {
          this.$message.error(res.msg || "评论加载失败");
          return;
        }
        const list = (res.data && res.data.list) || [];
        this.$set(item, "_commentList", list);
        this.$set(item, "_commentLoaded", true);
        if (res.data && res.data.totalCount != null) {
          this.$set(item, "comments", res.data.totalCount);
        }
      }).catch((err) => {
        this.$set(item, "_commentLoading", false);
        this.$message.error((err && err.msg) || "评论加载失败");
      });
    },
    handleSubmitComment(item) {
      if (!item || !item.id) return;
      if (!this.isLogged) {
        this.loginVisible = true;
        return;
      }
      const content = (item._commentDraft || "").trim();
      if (!content) {
        this.$message.warning("请输入评论内容");
        return;
      }
      if (item._commentSubmitting) return;
      this.$set(item, "_commentSubmitting", true);
      saveForumCommentApi({
        postId: item.id,
        content,
      }).then((res) => {
        this.$set(item, "_commentSubmitting", false);
        if (res.code !== 0) {
          this.$message.error(res.msg || "评论失败");
          return;
        }
        const comment = res.data || {};
        const list = item._commentList ? item._commentList.slice() : [];
        list.unshift(comment);
        this.$set(item, "_commentList", list);
        this.$set(item, "_commentDraft", "");
        this.$set(item, "comments", (item.comments || 0) + 1);
        this.$set(item, "_commentLoaded", true);
        this.$message.success(res.msg || "评论成功");
      }).catch((err) => {
        this.$set(item, "_commentSubmitting", false);
        this.$message.error((err && err.msg) || "评论失败");
      });
    },
    handleDeleteComment(item, comment) {
      if (!item || !comment || !comment.id) return;
      this.$confirm("确定删除这条评论吗？", "删除评论", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        return deleteForumCommentApi({ id: comment.id });
      }).then((res) => {
        if (res.code !== 0) {
          this.$message.error(res.msg || "删除失败");
          return;
        }
        const list = (item._commentList || []).filter((row) => row.id !== comment.id);
        this.$set(item, "_commentList", list);
        this.$set(item, "comments", Math.max(0, (item.comments || 0) - 1));
        this.$message.success(res.msg || "删除成功");
      }).catch((err) => {
        if (err === "cancel" || err === "close") return;
        this.$message.error((err && err.msg) || "删除失败");
      });
    },
    handleDeleteForumPost(item) {
      if (!item || !item.id) return;
      this.$confirm("确定删除这条分享吗？删除后不可恢复。", "删除分享", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        return deleteForumPostApi({ id: item.id });
      }).then((res) => {
        if (res.code !== 0) {
          this.$message.error(res.msg || "删除失败");
          return;
        }
        this.newsList = this.newsList.filter((row) => row.id !== item.id);
        this.total = Math.max(0, this.total - 1);
        if (this.newsList.length === 0 && this.pageNumber > 1) {
          this.pageNumber -= 1;
          this.getNewsList();
        }
        this.$message.success(res.msg || "删除成功");
      }).catch((err) => {
        if (err === "cancel" || err === "close") return;
        this.$message.error((err && err.msg) || "删除失败");
      });
    },
    //提交方案成功：新方案插到卡片列表顶部，状态为审核中
    handleProposalSuccess(payload) {
      const now = new Date();
      const createTime = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
      this.newsList.unshift({
        id: Date.now(),
        school: payload.school,
        title: payload.title,
        desc: payload.desc,
        status: "reviewing",
        createTime: createTime,
      });
      this.total += 1;
    },
    //投递简历：未登录先弹登录，已登录打开投递弹窗
    handleDeliverResume(item) {
      if (!this.isLogged) {
        this.loginVisible = true;
        return;
      }
      this.currentJob = item;
      this.resumeVisible = true;
    },
    //投递成功：mock 阶段仅提示，可扩展为岗位行标记"已投递"
    handleResumeSuccess() {},
    //登录弹窗 -> 注册弹窗
    handleOpenRegister() {
      this.loginVisible = false;
      this.registerVisible = true;
    },
    //注册弹窗 -> 登录弹窗
    handleToLogin() {
      this.registerVisible = false;
      this.loginVisible = true;
    },
    //注册成功 -> 回到登录弹窗
    handleRegisterSuccess() {
      this.registerVisible = false;
      this.loginVisible = true;
    },
    //重置列表数据：切 tab 时清空上一轮数据，避免新模板短暂渲染旧结构数据导致报错
    resetListData() {
      this.newsList = [];
      this.total = 0;
      this.pageNumber = 1;
    },
    OpenDetail(index) {
      this.tabIndex = index;
      this.resetListData();
      this.getNewsList();
    },
    CurrentIndex(index) {
      this.currentIndex = index;
    },
    //分页
    onPageChange(val) {
      // console.log(val);
      this.pageNumber = val;
      this.getNewsList();
    },
    //动态详情
    openNewDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    //论坛中心征稿详情
    openContributionDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 3,
        },
      });
    },
    //校园方案详情
    openCampusProposalDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 6,
        },
      });
    },
    //AI新闻详情
    openAiNewsDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 5,
        },
      });
    },
    //切换tab
    tabClick(index) {
      this.pageNumber = 1;
      // this.getNewsList()
    },
    //获取动态类型
    getNewsType() {
      getNewsTypeApi().then((res) => {
        this.newsTypeList = res.data || [];
        if (!this.newsTypeList.length) {
          this.newsTypeList = [{ id: 1, newType: "公司动态" }, ...newsTypeListData];
        }
        this.applyInitialTab();
        this.getNewsList();
      }).catch(() => {
        this.newsTypeList = [{ id: 1, newType: "公司动态" }, ...newsTypeListData];
        this.applyInitialTab();
        this.getNewsList();
      });
    },
    //详情页返回时按 query.tab 还原对应栏目
    applyInitialTab() {
      const tab = Number(this.$route.query.tab);
      if (tab && this.newsTypeList.some((item) => item.id === tab)) {
        this.tabIndex = tab;
        return;
      }
      this.tabIndex = this.newsTypeList[0].id;
    },
    //切换论坛帖子分类
    handleForumCategoryChange(key) {
      this.activeForumCategory = key;
      this.pageNumber = 1;
      this.getNewsList();
    },
    //数量格式化：超过1000显示 1.2k
    formatCount(n) {
      if (n >= 1000) {
        return (n / 1000).toFixed(1).replace(/\.0$/, "") + "k";
      }
      return n;
    },
    //切换AI新闻分类
    handleCategoryChange(key) {
      this.activeCategory = key;
      this.pageNumber = 1;
      this.getNewsList();
    },
    //企业动态列表
    getNewsList() {
      this.loading = true;
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: this.tabIndex,
      };
      const applyPage = (res) => {
        this.newsList = (res.data && res.data.list) || [];
        this.total = (res.data && res.data.totalCount) || 0;
        this.loading = false;
      };
      const failPage = () => {
        this.newsList = [];
        this.total = 0;
        this.loading = false;
      };
      if (this.tabIndex === 2) {
        getContributionListApi(data).then(applyPage).catch(failPage);
        return
      }
      if (this.tabIndex === 3) {
        getAiNewsListApi({
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
          category: this.activeCategory,
        }).then(applyPage).catch(failPage);
        return
      }
      if (this.tabIndex === 4) {
        getForumPostListApi({
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
          category: this.activeForumCategory,
        }).then(applyPage).catch(failPage);
        return
      }
      if (this.tabIndex === 5) {
        getCampusProposalListApi({
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        }).then(applyPage).catch(failPage);
        return
      }
      if (this.tabIndex === 6) {
        getJobPositionListApi({
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        }).then(applyPage).catch(failPage);
        return
      }
      getNewsListApi(data).then((res) => {
        // console.log("动态内容切换", res);
        this.newsList = res.data.list;
        this.total = res.data.totalCount;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.paging {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 8%;
}
.index_center {
  width: 1200px;
  /*width: 1360px;*/
  margin: 0 auto;
}

.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}

.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}

.el-breadcrumb__inner img {
  padding: 0 10px 0px 0;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.parkOverview {
  display: flex;
}

.parkOverview_left {
  /*width: 150px;*/
  padding-top: 30px;
}

.parkOverview_right {
  padding-top: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ParkOverview_info .info_block {
  width: 475px;
  /*background: red;*/
  margin-left: 172px;
  /*height: 325px;*/
}

.info_block .title {
  align-items: center;
  justify-content: space-between;
}

.advantage .li {
  width: 460px;
  color: white;
  height: 40px;
  text-align: center;
  margin-top: 15px;
  line-height: 40px;
  border-radius: 20px;
}

.ParkOverview_advantage .info_block {
  width: 475px;
}

.ParkOverview_advantage .img_list {
  width: 490px;
  height: 370px;
  flex-wrap: wrap;
  margin-right: 34px;
}

.ParkOverview_advantage .img_list img {
  margin-bottom: 10px;
  margin-right: 10px;
}

.ParkOverview_advantage .img_list img:nth-child(2n) {
  margin-right: 0px;
}

.ParkOverview_banner .center {
  width: 1200px;
  height: 267px;
  justify-content: space-between;
}

.center .li {
  width: 160px;
  height: 100%;
}

.center .li2 {
  width: 870px;
  height: 100%;
}

.center .li2 >>> .swiper-container {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.center .li2 >>> .swiper-wrapper {
  height: 100%;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.center .li2 .swiper-slide {
  height: 100%;
}

.center .li2 .item {
  flex: 1;
  height: 100%;
}

.ParkOverview_banner .title {
  align-items: center;
  width: 812px;
  justify-content: center;
}

.organization_list img {
  margin-left: 50px;
  margin-bottom: 10px;
}

.company_top .summary {
  line-height: 30px;
  color: white;
  background: #569fc8;
}

.company_top .li {
  flex: 1;
  height: 100%;
}

.company_bottom .li {
  flex: 1;
  height: 100%;
}

.company_bottom .li2 {
  flex: 2;
  height: 100%;
}

@media (max-width: 1400px) {
  .ParkOverview {
    max-width: 1200px;
  }
}

.ParkOverview_honor_img img {
  width: 972px;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
  /*background-color: red;*/
  background-image: linear-gradient(to right, #ffffff, rgba(41, 104, 189, 0.1));
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  /*text-align: center;*/
  width: 140px;
}

.TechnicalBar >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}

.Dynamic {
  padding-left: 65px;
  width: 1200px;
}

.Dynamic_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 20px;
  width: 100%;
}

.Dynamic_title_header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Dynamic_title_name {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}

.btn {
  font-weight: 600;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
  white-space: nowrap;
  outline: none;
  appearance: none;
  position: relative;
}

.Dynamic_title_btn {
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  height: 36px;
  padding: 0 16px;
}

.Dynamic_title_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.Dynamic_title_btn:active {
  box-shadow: 0 1px 3px rgba(27, 99, 167, .3);
  transform: translateY(1px);
}

.Dynamic_title_text {
  font-size: 14px;
  text-align: center;
}

.Dynamic_main_content_date1 p {
  padding-left: 10px;
}

.Dynamic_left_last {
  display: contents;
}

.Dynamic_left_content {
  width: 100%;
  padding: 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  height: 200px;
}
.Dynamic_left_content img {
  /* object-fit: cover; */
  width: 380px;
  height: 200px;
}

.Dynamic_left_content:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.Dynamic_right_content {
  width: 50%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: 8%;
  justify-content: space-between;
}

.Dynamic_right_content_icon {
  float: right;
  color: #2968bd;
  border: 2px solid #2968bd;
  border-radius: 50%;
  width: 25px;
  height: 23px;
  text-align: center;
  cursor: pointer;
}

.Dynamic_right_content_title {
  display: flex;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 15px;
}

.Dynamic_right_content_text {
  width: 500px;
  font-size: 14px;
  color: #666666;
  line-height: 30px;
}

.Dynamic_right_content_text p {
  /*超过三行省略号*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.Dynamic_right_content_bottom {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .el-divider--horizontal {
  margin-bottom: 80px;
} */

.pagination {
  padding-top: 88px;
}

.contribution_alert {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  padding: 10px 16px;
  margin-bottom: 20px;
}

.contribution_alert_text {
  font-size: 14px;
  color: #e6a23c;
}

.contribution_alert_text i {
  margin-right: 6px;
}

.contribution_alert_btn {
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  height: 32px;
  padding: 0 20px;
  font-weight: 600;
  cursor: pointer;
}

.contribution_alert_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.contribution_alert_btn:active {
  box-shadow: 0 1px 3px rgba(27, 99, 167, .3);
  transform: translateY(1px);
}

.contribution_section_title {
  box-sizing: border-box;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding: 5px 0 15px;
  border-left: 3px solid #1b63a7;
  padding-left: 10px;
  margin-bottom: 15px;
}

.contribution_item {
  box-sizing: border-box;
  width: 100%;
  padding: 20px 20px;
  border-bottom: 1px solid #e5e5e5;
  transition: background-color .2s ease;
}

.contribution_item:hover {
  background-color: #fafcff;
}

.contribution_item:hover .contribution_item_title {
  color: #0066cc;
}

.contribution_item:last-child {
  border-bottom: none;
  /* padding-bottom: 0; */
}

.contribution_item_header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.contribution_tag {
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  border-radius: 3px;
  padding: 2px 8px;
  line-height: 18px;
}

.contribution_tag--urgent {
  background: #f56c6c;
}

.contribution_tag--normal {
  background: #409eff;
}

.contribution_tag--medium {
  background: #67c23a;
}

.contribution_item_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.contribution_item_desc {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}

.contribution_item_desc >>> p {
  margin: 0;
}

.contribution_item_desc >>> img {
  display: none;
}

.contribution_item_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
}

.contribution_item_meta {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #999999;
}

.contribution_item_btn {
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  height: 32px;
  padding: 0 16px;
  font-weight: 600;
}

.contribution_item_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.contribution_item_btn.is_closed {
  background: #c0c4cc;
  cursor: not-allowed;
}

/* AI新闻 */
.ai_news_tabs {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  padding-bottom: 10px;
}

.ai_news_tab {
  height: 32px;
  padding: 0 18px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 14px;
}

.ai_news_tab.active {
  background: #1b63a7;
  border-color: #1b63a7;
  color: #fff;
}

.ai_news_item {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: 24px;
  padding: 25px 0;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
  transition: background-color .2s ease;
}

.ai_news_item:hover {
  background-color: #fafcff;
}

.ai_news_item:hover .ai_news_title {
  color: #0066cc;
}

.ai_news_item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.ai_news_cover {
  width: 240px;
  height: 160px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
}

.ai_news_cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ai_news_cover_placeholder {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 24px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  background: linear-gradient(135deg, #2968bd, #1b4e8a);
}

.ai_news_content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.ai_news_title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 12px;
}

.ai_news_summary {
  font-size: 14px;
  color: #666666;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.ai_news_footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 15px;
}

.ai_news_tag {
  font-size: 12px;
  color: #409eff;
  border: 1px solid #409eff;
  border-radius: 3px;
  padding: 1px 8px;
  line-height: 18px;
}

.ai_news_badge {
  font-size: 12px;
  color: #fff;
  border-radius: 3px;
  padding: 2px 8px;
  line-height: 18px;
}

.ai_news_date {
  font-size: 13px;
  color: #999999;
}

/* 论坛帖子 */
.forum_post_item {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: 16px;
  padding: 22px 0;
  border-bottom: 1px solid #e5e5e5;
}

.forum_post_item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.forum_post_avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.forum_post_body {
  flex: 1;
  min-width: 0;
}

.forum_post_header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
}

.forum_post_username {
  font-size: 14px;
  font-weight: 600;
  color: #2968bd;
}

.forum_post_time {
  font-size: 12px;
  color: #999999;
}

.forum_post_delete {
  margin-left: auto;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  color: #c0c4cc;
  cursor: pointer;
  line-height: 1;
}

.forum_post_delete:hover {
  color: #f56c6c;
}

.forum_post_content {
  font-size: 14px;
  color: #333333;
  line-height: 26px;
}

.forum_post_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 12px;
}

.forum_post_tag {
  font-size: 12px;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 3px;
  padding: 2px 10px;
  line-height: 20px;
}

.forum_post_stats {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-top: 12px;
  font-size: 13px;
  color: #999999;
}

.forum_post_stats i {
  margin-right: 4px;
}

.forum_stat_btn {
  padding: 0;
  border: none;
  background: none;
  font-size: 13px;
  color: #999999;
  cursor: pointer;
  line-height: 1;
}

.forum_stat_btn:hover,
.forum_stat_btn.active {
  color: #2968bd;
}

.forum_stat_btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.forum_comment_panel {
  margin-top: 14px;
  padding: 14px 16px;
  background: #f7f9fc;
  border-radius: 6px;
}

.forum_comment_editor {
  margin-bottom: 12px;
}

.forum_comment_submit {
  margin-top: 10px;
}

.forum_comment_login_tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #666666;
}

.forum_comment_empty {
  font-size: 13px;
  color: #999999;
  padding: 6px 0;
}

.forum_comment_item {
  padding: 10px 0;
  border-top: 1px solid #e8edf5;
}

.forum_comment_item:first-of-type {
  border-top: none;
  padding-top: 0;
}

.forum_comment_meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.forum_comment_user {
  font-size: 13px;
  font-weight: 600;
  color: #2968bd;
}

.forum_comment_time {
  font-size: 12px;
  color: #999999;
}

.forum_comment_delete {
  margin-left: auto;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  color: #c0c4cc;
  cursor: pointer;
}

.forum_comment_delete:hover {
  color: #f56c6c;
}

.forum_comment_content {
  margin: 0;
  font-size: 13px;
  color: #333333;
  line-height: 22px;
  word-break: break-word;
}

/* 校园分享-方案卡片 */
.campus_card_grid {
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 16px;
}

.campus_card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: box-shadow .2s ease, transform .2s ease;
}

.campus_card:hover {
  box-shadow: 0 4px 14px rgba(27, 99, 167, .12);
}

.campus_card:hover .campus_card_title {
  color: #0066cc;
}

.campus_card_stripe {
  height: 6px;
}

.campus_card_body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 6px);
  box-sizing: border-box;
}

.campus_card_school {
  font-size: 14px;
  font-weight: 600;
  color: #2968bd;
  padding-bottom: 8px;
}

.campus_card_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 8px;
}

.campus_card_desc {
  font-size: 13px;
  color: #666666;
  line-height: 24px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}

.campus_card_desc >>> p {
  margin: 0;
}

.campus_card_desc >>> img {
  display: none;
}

.campus_card_footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
}

.campus_card_status {
  font-size: 12px;
  border-radius: 3px;
  padding: 2px 10px;
  line-height: 20px;
}

.campus_card_date {
  font-size: 13px;
  color: #999999;
}

/* 人才招聘-在招岗位 */
.job_item {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 20px 24px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.job_item + .job_item {
  margin-top: 16px;
}

.job_item_content {
  flex: 1;
  min-width: 0;
}

.job_item_header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding-bottom: 10px;
}

.job_item_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.job_item_salary {
  font-size: 15px;
  font-weight: 600;
  color: #f56c6c;
}

.job_item_info {
  display: flex;
  gap: 20px;
  padding-top: 12px;
  font-size: 13px;
  color: #999999;
}

.job_item_btn {
  flex-shrink: 0;
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  height: 36px;
  padding: 0 20px;
}

.job_item_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.job_item_btn:active {
  box-shadow: 0 1px 3px rgba(27, 99, 167, .3);
  transform: translateY(1px);
}
</style>



// WEBPACK FOOTER //
// src/views/ParkOverview.vue